import React, { useEffect, useState, useMemo } from 'react'
import { ErrorNotification } from 'services/helpers/helpers'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { getContent } from 'services/ContentfulApi'
import { ContentfulPageContentWrapper } from 'components/Contentful/ContentfulPageContentWrapper'
import { getContentfulNodeRenderers } from 'services/helpers/getContentfulNodeRenderers'

export const useContentful = (contentfulUrl: string, contentfulToken: string, language: string) => {
  const [pages, setPages] = useState<any[]>([])
  const [assets, setAssets] = useState<any[]>([])
  const [contacts, setContacts] = useState<any[] | null>(null)
  const [posts, setPosts] = useState<any[]>([])
  const [isAuthLoading, setIsAuthLoading] = useState<boolean>(false)
  const [isContentfulLoading, setIsContentfulLoading] = useState<boolean>(true)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pageResult = await getContent(contentfulUrl, contentfulToken, 'page', language)
        const contactResult = await getContent(
          contentfulUrl,
          contentfulToken,
          'contactUs',
          language
        )
        const postResult = await getContent(contentfulUrl, contentfulToken, 'newsPost', language)
        setAssets(pageResult.includes?.Asset)
        setPages(pageResult.items)
        setPosts(postResult.items)
        setContacts(contactResult.items)
      } catch (error) {
        ErrorNotification(
          'Could not load content',
          'Some content is not accessible. Try again later'
        )
      } finally {
        setIsContentfulLoading(false)
      }
    }

    fetchData()
  }, [contentfulUrl, contentfulToken, language])

  const nodeRenderingOptions = useMemo(() => getContentfulNodeRenderers(assets), [assets])

  const renderPageContent = (content) => {
    return (
      <ContentfulPageContentWrapper>
        {documentToReactComponents(content, nodeRenderingOptions)}
      </ContentfulPageContentWrapper>
    )
  }

  return {
    pages,
    posts,
    contacts,
    isContentfulLoading,
    isAuthLoading,
    setIsAuthLoading,
    renderPageContent,
  }
}
